import { get, push, ref, update } from "firebase/database";
import { db } from "../lib/firebase";
import { getPathDatabaseByRole } from "./auth";
import { getUserID } from "./getters";
import { LaunchError } from "../utils/errors";
import { getBrandSetupChangedFields } from "../pages/Settings/BrandSetup/utils/brandSetupDiff";

export const startGetBrandSetupVersions = () => async (dispatch) => {
  try {
    const { pathBrandSetupVersions } = dispatch(getPathDatabaseByRole());
    const snapshot = await get(ref(db, pathBrandSetupVersions));

    if (!snapshot.exists()) {
      return { ok: true, data: [] };
    }

    const versionsData = snapshot.val();
    const versions = Object.entries(versionsData).map(
      ([versionID, version = {}]) => ({
        versionID,
        versionNumber: version.versionNumber,
        createdAt: version.createdAt,
        createdByUserID: version.createdByUserID,
        source: version.source,
        changedFields: version.changedFields || [],
      })
    );

    versions.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));

    return { ok: true, data: versions };
  } catch (error) {
    dispatch(
      LaunchError(error, true, [], {
        functionName: "startGetBrandSetupVersions",
        context: {},
        tags: { action: "getBrandSetupVersions" },
        level: "error",
      })
    );
    return { ok: false };
  }
};

export const startSaveBrandSetupVersion =
  ({ apiData, previousApiData, source = "manual_save" }) =>
  async (dispatch) => {
    try {
      const {
        pathBrandSetupVersions,
        userID: advertiserID,
        role,
      } = dispatch(getPathDatabaseByRole());
      const changedFields = getBrandSetupChangedFields({
        currentData: apiData,
        previousData: previousApiData,
      });

      if (changedFields.length === 0) {
        return { ok: true, skipped: true };
      }

      const existingSnapshot = await get(ref(db, pathBrandSetupVersions));
      const existingVersions = existingSnapshot.exists()
        ? existingSnapshot.val()
        : {};
      const versionNumber = Object.keys(existingVersions).length + 1;
      const createdByUserID = dispatch(getUserID());
      const createdAt = new Date().getTime();
      const versionID = push(ref(db, pathBrandSetupVersions)).key;
      const updates = {};

      updates[`${pathBrandSetupVersions}/${versionID}`] = {
        versionNumber,
        advertiserID,
        createdAt,
        createdAtNegative: createdAt * -1,
        createdByUserID,
        createdByRole: role,
        source,
        changedFields,
        snapshot: apiData,
      };

      await update(ref(db), updates);

      return { ok: true, versionID, versionNumber };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startSaveBrandSetupVersion",
          context: {},
          tags: { action: "saveBrandSetupVersion" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };

export const startGetBrandSetupVersionSnapshot =
  ({ versionID }) =>
  async (dispatch) => {
    try {
      const { pathBrandSetupVersions } = dispatch(getPathDatabaseByRole());
      const snapshot = await get(
        ref(db, `${pathBrandSetupVersions}/${versionID}/snapshot`)
      );

      if (!snapshot.exists()) {
        return { ok: false };
      }

      return { ok: true, data: snapshot.val() };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startGetBrandSetupVersionSnapshot",
          context: {},
          tags: { action: "getBrandSetupVersionSnapshot" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };
